
import { computed, defineComponent, PropType, ref } from 'vue'
import { IArrowL } from '@/components/icons'

export default defineComponent({
    emits: ['update:modelValue'],
    name: 'drop-down',
    components: {
        IArrowL
    },
    props: {
        labelName: {
            type: String as PropType<string>
        },
        listData: {
            required: true,
            type: Array as PropType<Array<any>>
        },
        modelValue: {
            type: Number as PropType<number>
        }
    },
    setup(props, { emit }) {
        const showList = ref<boolean>(false)

        const handleClickOutside = () => {
            showList.value = false
        }

        const handleListItemClick = (value: number) => {
            emit('update:modelValue', value)
            showList.value = false
        }

        const getLabel = (_index: number) => {
            const item = props.listData[_index]
            if (props.labelName) {
                return item[`${props.labelName}`]
            }

            return item
        }

        const label = computed(() => {
            if (!props.listData || props.listData.length === 0) {
                return '没有数据'
            } else {
                const item = props.listData[props.modelValue!]
                if (item) {
                    if (props.labelName) {
                        return item[`${props.labelName}`]
                    }

                    return item
                }
                return '没有数据'
            }
        })

        return {
            showList,
            label,
            getLabel,
            // methods
            handleClickOutside,
            handleListItemClick
        }
    }
})
